import React, { useEffect, useState } from 'react'
import Endpoint from './Endpoint'

import { Button } from '@govtechsg/sgds-react/Button'

import arrowleft from '../assets/icons/arrow-left.svg'
import arrowright from '../assets/icons/arrow-right.svg'

const NotificationComponent = ({ clickButton, endpointreturn }) => {

    const cardStyle = {
        boxShadow: '0 8px 16px 6px rgba(60, 64, 67, .2), 0 2px 6px 0 rgba(60, 64, 67, .4)',
        marginBottom: '30px',
        transition: 'all 0.3s ease',
        backgroundColor: "#ffcc4d", 
        "padding": "20px 15px", marginBottom: "35px", borderRadius: "15px"
    };

    const [showNotification, setShowNotification] = useState(false);

    useEffect(() => {
        const checkTimeWindow = () => {
            const now = new Date();
            const startTime = new Date('2025-06-16T09:00:00+08:00'); // 16 June 9AM SGT
            const endTime = new Date('2025-06-17T09:00:00+08:00');   // 17 June 9AM SGT
            
            setShowNotification(now >= startTime && now <= endTime);
        };

        // Check immediately
        checkTimeWindow();

        // Check every minute
        const interval = setInterval(checkTimeWindow, 60000);

        // Cleanup
        return () => clearInterval(interval);
    }, []);

    if (!showNotification) return null;

   return (
    <div style={cardStyle}>
        <p>Dear OneMap Users,</p>

        <p>We would like to inform you that OneMap services and APIs services will be <b>temporarily unavailable</b> for maintenance on <b>Tuesday, 17 June 2025 from 00:00 to 02:00 (SGT).</b></p>

        <p>If you have any questions, reach out to us at <a href="https://go.gov.sg/onemap-feedback-form">support form.</a> </p>
        
        <p>Thank you.</p>
        Warmest regards,<br/>
        OneMap Team
    </div>
   ); 
}

export default NotificationComponent;
